<template>
    <div class="portal-home">
        <v-row v-if="banner">
            <v-col cols="12">
                <v-alert dense outlined prominent text  :type="banner.type">
                    <h2>{{banner.title}}</h2>
                    <p>{{banner.message}}</p>
                </v-alert>
            </v-col>
        </v-row>
        <v-row class="mb-2"> 
            <v-col cols="12" sm="6" md="3"> 
             <inertia-link :href="'/portal/calendar/appointments'" >
                <v-card>
                    <v-card-title>{{ $page.props.lang.upcoming_classes || "My Appointments" }}</v-card-title>
                    <v-card-subtitle>{{ $page.props.lang.coming_month || "For the next 30 days" }}</v-card-subtitle>
                    <v-row>
                        <v-col  cols="4">
                            <v-avatar size="50" tile>
                                <v-icon>mdi-account-multiple-check-outline</v-icon>
                            </v-avatar>
                        </v-col>
                        <v-col cols="8" class="text-right">
                            <h2 class="value">{{ classes['upcoming_classes'] }}</h2>
                        </v-col>
                    </v-row>                     
                </v-card>
            </inertia-link>
            </v-col>
            <v-col cols="12" sm="6" md="3">
            <inertia-link :href="'/portal/calendar/appointments/past'" >
                    <v-card>
                        <v-card-title>{{ $page.props.lang.class_attended || "Past Appointments" }}</v-card-title>
                        <v-card-subtitle>{{ $page.props.lang.past_month || "Last 30 days" }}</v-card-subtitle>
                        <v-row>
                            <v-col cols="4">
                                <v-avatar size="50" tile>
                                    <v-icon>mdi-card-account-mail-outline</v-icon>
                                </v-avatar>
                            </v-col>
                            <v-col cols="8" class="text-right">
                                <h2 class="value">{{ classes['classes_attended'] }}</h2>
                            </v-col>
                        </v-row>                     
                    </v-card>
            </inertia-link>
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <a href="javascript:void(0)">
                    <v-card @click="openMemberCardDetails()" style="height:157px;">
                        <v-card-title style="padding-bottom:5px">{{ $page.props.lang.membership_card || "Membership Card" }}</v-card-title>
                        <v-row>
                            <v-col cols="12" class="text-center" >
                            <barcode :value="cardNumber" width="1" height="50" displayValue="false"></barcode>
                            </v-col>
                        </v-row>                     
                    </v-card>
                </a>
            </v-col> 
        </v-row>
        <h3 v-if="banner == null" class="pl-4 mt-6 mb-2">{{ $page.props.lang.active_subscriptions || "Active memberships" }}</h3>
        <v-row>
                <v-col cols="12" sm="6" md="3" v-for="subscription in classes['activeSubscriptions']" :key="subscription.id">
                    <v-card @click="openDetailsModal(subscription)">
                        <v-card-title>{{ subscription.name }}</v-card-title>
                        <v-card-subtitle>{{ $page.props.lang.current_period || "Current Period" }}: {{ subscription.current_period }}</v-card-subtitle>
                        <v-row>
                            <v-col cols="6 text-left">
                                <v-chip v-if="subscription.contains_unpaid"  class="ma-2 mt-4" color="red" text-color="white" small>
                                    <v-icon small left>mdi-alert-circle-outline</v-icon>
                                    {{ $page.props.lang.unpaid || "Unpaid"}}
                                </v-chip>
                                <v-chip v-else class="ma-2 mt-4" color="#4ede77" text-color="white" small> 
                                    <v-icon small left color="white">mdi-currency-usd</v-icon>
                                    {{ $page.props.lang.paid || "Paid"}} 
                                </v-chip>
                            </v-col>
                            <v-col cols="6" class="text-right">
                               <span v-if="subscription.remaining == '∞'" class="grey--text text--darken-2 font-weight-medium text-h3">{{subscription.remaining}}</span>
                               <span v-else class="font-weight-medium grey--text text--darken-2">{{subscription.remaining}}</span>
                            </v-col>
                        </v-row> 
                    </v-card>
                </v-col>
        </v-row>
        <v-dialog v-model="detailsModal" max-width="430px">
            <v-card class="view-panel">
                <div class="modal-header">
                    <h4 class="modal-headline">{{ currentSub.name }} </h4>
                    <div class="tools">
                        <v-btn icon @click="detailsModal = false"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <div class="info-container">
                    <div class="grid bottom">
                    
                        <div class="info-group">
                            <div class="icon-wrap"><v-icon>mdi-calendar-text-outline</v-icon></div>
                            <div class="info-wrap">
                                <p class="label">{{ $page.props.lang.exp_date || "Expiration Date" }}</p>
                                <p class="value">{{ currentSub.current_end_date }}</p>
                            </div>
                        </div>
                        <div class="info-group">
                            <div class="icon-wrap"><v-icon>mdi-account-check-outline</v-icon></div>
                            <div class="info-wrap">
                                <p class="label">{{ $page.props.lang.details_app_left || 'Appointments' }}</p>
                                <p class="value" style="font-weight:bold">{{ currentSub.remaining }}</p>
                            </div>
                        </div>
                        <div class="info-group">
                            <div class="icon-wrap"><v-icon>mdi-currency-usd</v-icon></div>
                            <div class="info-wrap">
                                <p class="label">{{ $page.props.lang.details_mem_price || 'Membership Price' }}</p>
                                <p class="value">{{ currentSub.mem_price }} {{$page.props.organization.settings.currency}}</p>
                            </div>
                        </div>
                        <div class="info-group">
                            <div class="icon-wrap"><v-icon>mdi-cash-100</v-icon></div>
                            <div class="info-wrap">
                                <p class="label">Status</p>
                                <span class="value" v-if="currentSub.is_paid == 1"><v-icon small color="green" style="padding-bottom:3px; padding-right:3px"> mdi-check-circle-outline </v-icon>Plaćeno</span>
                                <span class="value"  v-else><v-icon small color="red" style="padding-bottom:3px; padding-right:3px"> mdi-alert-circle-outline </v-icon>Neplaćeno</span>
                            </div>
                        </div>
                    </div>
                    <div class="clients-group">
                        <p class="label"><v-icon>mdi-dumbbell</v-icon>{{ $page.props.lang.details_available_courses || 'Available Courses' }}</p>
                        <v-chip v-if="is_limited == 0">{{ $page.props.lang.details_all || 'All' }}</v-chip>
                        <ul v-else class="clients">
                            <li v-for="(item, index) in currentSub.courses" :key="index">
                                <v-chip style="margin:1px">{{ item.course.title }}</v-chip>
                            </li>
                        </ul>
                    </div>
                    <div class="clients-group">
                        <p class="label"><v-icon>mdi-format-list-bulleted</v-icon> {{ $page.props.lang.details_periods || 'All past periods' }}</p>
                        <ul class="clients">
                            <v-simple-table dense v-if="this.past_periods == 1">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-left">
                                                {{ $page.props.lang.current_period || 'Period' }}
                                            </th>
                                            <th class="text-left">
                                                {{ $page.props.lang.details_app_left || 'Appointments' }}
                                            </th>
                                            <th class="text-center">
                                                {{ $page.props.lang.details_status || 'Paid' }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in currentSub.periods" :key="item.id">
                                            <td>{{ item.start_date | formatDate}} - {{ item.end_date | formatDate}}</td>
                                            <td class="text-center"><span v-if="item.remaining_visits == 0">∞</span><span v-else>{{ item.total_visits }} / {{ item.remaining_visits}}</span></td>
                                            <td class="text-center">
                                                <v-icon v-if="item.is_paid == 1" color="green"> mdi-check-circle-outline </v-icon>
                                                <v-icon v-else color="red"> mdi-alert-circle-outline </v-icon>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                            <span v-else style="font-weight:bold">{{$page.props.lang.noPeriods || 'No past periods available.'}}</span>
                        </ul>
                    </div>
                </div>
            </v-card>
        </v-dialog>
         <MembershipCard v-if="showMembershipCard" :open="showMembershipCard"></MembershipCard>
    </div>
</template>

<script>
import PortalLayout from '@/js/Layouts/PortalLayout'
import VueBarcode from 'vue-barcode';
import MembershipCard from './Components/Card'
import EventBus from '../../../eventbus';

export default {
    layout: PortalLayout,
    components: {
       'barcode': VueBarcode, MembershipCard
    },
    metaInfo() {
        return {
            title:  this.organization.name
        }
    },
    created() {
        EventBus.$on('CLOSE_MEMBERSHIP_CARD_MODAL', (p) => {
            this.showMembershipCard = false
        })
    },
    data(){
        return {
            detailsModal: false,
            showMembershipCard: false,
            currentSub: {
                name: '',
                current_period:'',
                remaining: '',
                start_date: '',
                end_date: ''
            },
            model:1,
            is_limited: null,
            past_periods: null,
            cardData: null
        }
    },
    props:{
        classes: Object,
        banner: Object,
        organization: Object,
        cardNumber: String
    },

    methods: {
        openDetailsModal(sub){
            this.currentSub = sub;
            this.detailsModal = true;

            if(this.currentSub.courses.length == 0){
                this.is_limited = 0;
            }else{
                this.is_limited = 1;
            }
            if(this.currentSub.periods.length == 0){
                this.past_periods = 0;
            }else{
                this.past_periods = 1;
            }
        },
        openMemberCardDetails() {
            this.showMembershipCard = true;
        }
    }
}
</script>